import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e6fdf866"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "spinner-overlay"
};
var _hoisted_2 = {
  class: "download-all"
};
var _hoisted_3 = {
  class: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    class: "download-tickets-popup",
    title: _ctx.$t('completeorder.list-of-tickets'),
    width: "80%",
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    "show-close": false
  }, {
    default: _withCtx(function () {
      return [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      })])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "custom-close",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.closeModal && _ctx.closeModal.apply(_ctx, arguments);
        })
      }, "×"), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _ctx.DownloadIcon,
        onClick: _withModifiers(_ctx.downloadAllTickets, ["stop"]),
        disabled: _ctx.loading
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.download-all")), 1)];
        }),
        _: 1
      }, 8, ["icon", "onClick", "disabled"])]), _createVNode(_component_el_row, {
        style: {
          "font-weight": "700",
          "border-bottom": "1px solid grey",
          "padding-bottom": "15px",
          "padding-top": "15px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            class: "column",
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.ticket-name")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "column",
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.price-name")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "column",
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.price-value")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "column",
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("orders.customer-full-name")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "column",
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.bar-code")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "column",
            span: 4
          })];
        }),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticektsInfo, function (data, index) {
        return _openBlock(), _createElementBlock("div", {
          key: String(data.pss.uuid)
        }, [_createVNode(_component_el_row, {
          style: _normalizeStyle([{
            "padding-bottom": "15px",
            "padding-top": "15px"
          }, index !== _ctx.ticektsInfo.length - 1 ? 'border-bottom: 1px solid grey' : ''])
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_col, {
              style: {
                "text-align": "left",
                "font-weight": "700"
              },
              span: 4,
              class: "d-flex fl-col fl-j-c column"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(data.pss.categoryName), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c column"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(data.pss.priceName), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(data.pss.priceValue / 100 + " " + _ctx.currency), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c column"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(data.firstName + " " + data.lastName), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(data.pss.barCode ? data.pss.barCode : "-"), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              style: {
                "text-align": "right",
                "padding-right": "10px"
              },
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_3, [_ctx.isMembershipTicket(data.pss) ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "download-button",
                  icon: _ctx.badgeIcon,
                  disabled: _ctx.loading,
                  onClick: function onClick($event) {
                    return _ctx.downloadBadge(data.pss);
                  }
                }, null, 8, ["icon", "disabled", "onClick"])) : _createCommentVNode("", true), data.pss.type === _ctx.PCTypes.GiftCard ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  class: "download-button",
                  icon: _ctx.badgeIcon,
                  disabled: _ctx.loading,
                  onClick: function onClick($event) {
                    return _ctx.downloadGiftcard(data.pss);
                  }
                }, null, 8, ["icon", "disabled", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
                  class: "download-button",
                  icon: _ctx.DownloadIcon,
                  disabled: _ctx.loading,
                  onClick: _withModifiers(function ($event) {
                    return _ctx.downloadTicket(data.pss);
                  }, ["stop"])
                }, null, 8, ["icon", "disabled", "onClick"])])];
              }),
              _: 2
            }, 1024)];
          }),
          _: 2
        }, 1032, ["style"])]);
      }), 128))])];
    }),
    _: 1
  }, 8, ["title", "modelValue"]);
}